const errorUtility = {
  /**
   *
   * @param {String} message
   * @param {Number} code
   * @param {Object} data
   * @returns {CustomError}
   */
  buildCustomError(message, code, data) {
    return new CustomError(message, code, data);
  },
  /**
   *
   * @param {Function} translator
   * @param {Object} context The context to bind to the translator function
   * @param {Error} error
   * @returns {Object}
   */
  process(translator, context, error) {
    const $t = translator.bind(context);
    return error.response
      ? composeWithResponse($t, error)
      : composeNoResponse($t, error);
  },
};

export default errorUtility;

/**
 *
 * @param {Function} $t
 * @param {Error} error
 * @returns {Object}
 */
const composeWithResponse = ($t, error) => {
  const data = error.response.data;
  return {
    data: {
      message:
        data && data.message
          ? data.message
          : data.error
            ? data.error
            : $t('alerts.noMessage'),
    },
    status: error.response.status ? error.response.status : $t('alerts.noCode'),
  };
};

/**
 *
 * @param {Function} $t
 * @param {Error} error
 * @returns {Object}
 */
const composeNoResponse = ($t, error) => {
  return {
    data: {
      message: error.request
        ? $t('alerts.unansweredRequest')
        : $t('alerts.triggeredAnError'),
    },
    status: 503,
  };
};

class CustomError extends Error {
  constructor(message, code, data) {
    super(message);
    this.code = code;
    this.response = new Response(code, data);
  }
}

class Response {
  constructor(status, data) {
    this.status = status;
    this.data = data;
  }
}
